module.exports = __webpack_public_path__ + "static/what-we-do-0ef3dfca4a1b7e61c8c366c8fd4311ca.webp";